import { createFileRoute } from '@tanstack/react-router'
import { ReviewsScreen } from '../features/reviews'

function Reviews() {
  const { workspaceId } = Route.useParams()
  const navigate = Route.useNavigate()
  return (
    <ReviewsScreen
      workspaceId={workspaceId}
      onOpenSubmission={(submissionId) => {
        void navigate({
          to: '/w/$workspaceId/reviews/$submissionId',
          params: { workspaceId, submissionId },
        })
      }}
    />
  )
}

export const Route = createFileRoute('/w/$workspaceId/reviews/')({ component: Reviews })
